import React, { useContext, useEffect, useState } from 'react';
import { paths } from 'src/utils/paths';
import Link from 'next/link';
import { classNames } from 'src/utils/classNames';
import { ChatContext } from 'src/client/contexts/chat';
import { initializeGraphqlClient } from 'src/client/graphql/client';
import {
  CurrentUserDocument,
  WorkerProfileDocument,
  WorkerProfileQuery,
  WorkerProfileQueryVariables,
} from 'src/client/generated';

type Props = {
  token: string;
};

/**
 * ログイン状態に表示するフッター
 */
function LoggedInFooter({ token }: Props) {
  const [currentPath, setCurrentPath] = useState('');
  const { chatClient, unreadCount, chatDispatch } = useContext(ChatContext);

  useEffect(() => {
    setCurrentPath(location.pathname);
  }, []);

  useEffect(() => {
    if (chatClient != null) {
      return;
    }
    (async () => {
      const graphqlClient = initializeGraphqlClient();
      const {
        data: { currentUser },
      } = await graphqlClient.query({
        query: CurrentUserDocument,
        variables: { token },
      });
      const { data } = await graphqlClient.query<WorkerProfileQuery, WorkerProfileQueryVariables>({
        query: WorkerProfileDocument,
        variables: { id: currentUser.id, token },
      });
      const { representativeImage, firstName, lastName } = data.workerProfile;
      const name = lastName + ' ' + firstName;
      await chatDispatch({
        type: 'initializeChatClient',
        payload: {
          token,
          user: { id: currentUser.id, name, image: representativeImage ? representativeImage : undefined },
        },
      });
    })();
  }, [chatClient]);

  return (
    <div className="actions-footer">
      <div className="w-full flex  box-border border-solid border-t border-gray fixed bottom-0 bg-white justify-around footer-wrapper">
        {/*「探す」は一旦Topに遷移させる仕様*/}
        {/*https://shiftus.slack.com/archives/C72PA4PPH/p1605697084317500*/}
        <Link href={paths.top}>
          <a className="icons-margin" aria-label="さがすボタン">
            <img
              src={currentPath === paths.top ? '/icons/footer-search-green.svg' : '/icons/footer-search-gray.svg'}
              alt=""
            />
          </a>
        </Link>
        <Link href={paths.application.schedule}>
          <a
            className={classNames(
              'icons-margin flex items-center flex-col text-light-gray4',
              currentPath === paths.application.schedule && 'pointer-events-none text-[#48AFAA]',
            )}
          >
            <img
              src={
                currentPath === paths.application.schedule
                  ? '/icons/footer-experience-green.svg'
                  : '/icons/footer-experience-gray.svg'
              }
              alt=""
            />
            <span
              className={`text-[8px] leading-3 mt-[2px] ${
                currentPath === paths.application.schedule ? 'text-green' : ''
              }`}
            >
              応募
            </span>
          </a>
        </Link>
        <Link href={paths.chat}>
          <a className={classNames('icons-margin', 'relative', currentPath === paths.chat && 'pointer-events-none')}>
            {unreadCount > 0 ? (
              <span className="right-[-3px] w-[17px] h-[17px] top-[-3px] text-[11px] rounded-[50%] text-white justify-center flex absolute items-center bg-[#eb4e3d]">
                {unreadCount}
              </span>
            ) : null}
            <img
              src={currentPath === paths.chat ? '/icons/footer-message-green.svg' : '/icons/footer-message-gray.svg'}
              alt=""
            />
          </a>
        </Link>
        <Link href={paths.accounts.favoriteRecruitments}>
          <a
            className={classNames(
              'icons-margin',
              currentPath === paths.accounts.favoriteRecruitments && 'pointer-events-none',
            )}
          >
            <img
              src={
                currentPath == paths.accounts.favoriteRecruitments
                  ? '/icons/footer-favorite-green.svg'
                  : '/icons/footer-favorite-gray.svg'
              }
              alt=""
            />
          </a>
        </Link>
        <Link href={paths.accounts.mypage}>
          <a className={classNames('icons-margin', currentPath === paths.accounts.mypage && 'pointer-events-none')}>
            <img
              src={
                currentPath === paths.accounts.mypage
                  ? '/icons/footer-mypage-green.svg'
                  : '/icons/footer-mypage-gray.svg'
              }
              alt=""
            />
          </a>
        </Link>
      </div>
      <style jsx>{`
        .actions-footer {
          height: var(--global-footer-height);
        }
        .icons-margin {
          margin: 10px 0 3px;
        }
        .footer-wrapper {
          padding-bottom: constant(safe-area-inset-bottom);
          padding-bottom: env(safe-area-inset-bottom);
        }
      `}</style>
    </div>
  );
}

export default LoggedInFooter;
